/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Communitytitle1Inputs */

const id_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berbasis Komunitas`)
};

const ms_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Didorong Komuniti`)
};

const da_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fællesskabsdrevet`)
};

const de_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community-Getrieben`)
};

const en_us2_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community Driven`)
};

const es_es2_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impulsado por la comunidad`)
};

const es_mx2_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impulsado por la comunidad`)
};

const fil_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinapatakbo ng Komunidad`)
};

const fr_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piloté par la communauté`)
};

const it_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guidato dalla community`)
};

const hu_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Közösség által működtetett`)
};

const nl_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community-gestuurd`)
};

const no_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fellesskapsdrevet`)
};

const pl_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napędzane przez społeczność`)
};

const pt_br2_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orientado pela comunidade`)
};

const pt_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orientado pela comunidade`)
};

const ro_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condus de comunitate`)
};

const fi_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteisön ylläpitämä`)
};

const sv_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community-driven`)
};

const vi_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều hành bởi cộng đồng`)
};

const tr_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topluluk Odaklı`)
};

const cs_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Řízeno komunitou`)
};

const bg_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ръководен от общността`)
};

const ru_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управляется сообществом`)
};

const uk_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спільнота`)
};

const ar_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدفوع من المجتمع`)
};

const hi_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समुदाय संचालित`)
};

const th_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขับเคลื่อนโดยชุมชน`)
};

const ja_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コミュニティ主導`)
};

const zh_cn2_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社区驱动`)
};

const zh_hant1_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社群驅動`)
};

const ko_privacy_communitytitle1 = /** @type {(inputs: Privacy_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커뮤니티 기반`)
};

/**
* | output |
* | --- |
* | "Community Driven" |
*
* @param {Privacy_Communitytitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_communitytitle1 = /** @type {((inputs?: Privacy_Communitytitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Communitytitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_communitytitle1(inputs)
	if (locale === "ms") return ms_privacy_communitytitle1(inputs)
	if (locale === "da") return da_privacy_communitytitle1(inputs)
	if (locale === "de") return de_privacy_communitytitle1(inputs)
	if (locale === "en-US") return en_us2_privacy_communitytitle1(inputs)
	if (locale === "es-ES") return es_es2_privacy_communitytitle1(inputs)
	if (locale === "es-MX") return es_mx2_privacy_communitytitle1(inputs)
	if (locale === "fil") return fil_privacy_communitytitle1(inputs)
	if (locale === "fr") return fr_privacy_communitytitle1(inputs)
	if (locale === "it") return it_privacy_communitytitle1(inputs)
	if (locale === "hu") return hu_privacy_communitytitle1(inputs)
	if (locale === "nl") return nl_privacy_communitytitle1(inputs)
	if (locale === "no") return no_privacy_communitytitle1(inputs)
	if (locale === "pl") return pl_privacy_communitytitle1(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_communitytitle1(inputs)
	if (locale === "pt") return pt_privacy_communitytitle1(inputs)
	if (locale === "ro") return ro_privacy_communitytitle1(inputs)
	if (locale === "fi") return fi_privacy_communitytitle1(inputs)
	if (locale === "sv") return sv_privacy_communitytitle1(inputs)
	if (locale === "vi") return vi_privacy_communitytitle1(inputs)
	if (locale === "tr") return tr_privacy_communitytitle1(inputs)
	if (locale === "cs") return cs_privacy_communitytitle1(inputs)
	if (locale === "bg") return bg_privacy_communitytitle1(inputs)
	if (locale === "ru") return ru_privacy_communitytitle1(inputs)
	if (locale === "uk") return uk_privacy_communitytitle1(inputs)
	if (locale === "ar") return ar_privacy_communitytitle1(inputs)
	if (locale === "hi") return hi_privacy_communitytitle1(inputs)
	if (locale === "th") return th_privacy_communitytitle1(inputs)
	if (locale === "ja") return ja_privacy_communitytitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_communitytitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_communitytitle1(inputs)
	return ko_privacy_communitytitle1(inputs)
});
export { privacy_communitytitle1 as "privacy.communityTitle" }